import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import { useAppState } from '../contexts/appState';
import { usePopup, useSelectedBusiness } from '../hooks';
import { generateLeads, handleImpressionsTrack } from '../api/home';
import { handleLoginPopup, handleSetFaqData } from '../reducersAndActions/actions/appStateActions';
import {
  andriodSource,
  clickTracker,
  env,
  getContractTypeVal,
  getCookie,
  getProjectId,
  getSourceValue,
  getTextWithNoSpace,
  getUserType,
  handleJdPayRedirection,
  handleRedirection,
  hasJdMartVertical,
  iosSource,
  touchSource,
  trackerObj,
  trackUserType,
  userTypeTrackerObj,
  webSource,
} from '../lib/common';
import { onClickEvent } from '../lib/gaAnalytics';
import { CreateTicket, getClickTrackersInfo } from '../api';
import useAlert from '../hooks/useAlert';
import { BusinessPopup, CommonPopup, LoggedIn, NonLoginBody, NonLoginHome, OthersPopup, Shimmer } from '../components';
import '../styles';

function Home() {
  const navigate = useNavigate();
  const [authState] = useAuth();
  const [appState, appDispatch] = useAppState();
  const [, setUserDetails] = useState('userDetails', '');
  const source = getSourceValue();
  const [comment, setComment] = useState('');
  const [setAlert] = useAlert();
  const { setSelectedBusinessState } = useSelectedBusiness();
  const [setPopup] = usePopup();
  const { loader, popupObj, optionsData } = appState;
  const { allBusinesses, selectedBusiness, type, userDetails, sidResponse } = authState;
  const queryParams = new URLSearchParams(window.location.search);
  const urlDocId = queryParams.get('docid') || '';
  const createTicketFlag = queryParams.get('createTicket') || '';
  const [isBusinessChange, setIsBusinessChange] = useState(false);
  const [, setPopupTitle] = useState('');
  const [othersPopupData, setOthersPopupData] = useState([]);
  const [optionsTrackerData, setOptionsTrackerData] = useState([]);
  const projectId = getProjectId();
  const contractType = getContractTypeVal(projectId);
  sessionStorage.removeItem('feedback');
  sessionStorage.removeItem('faqsFeedback');
  sessionStorage.removeItem('bannerType');
  sessionStorage.removeItem('activeBannerFlag');

  const handleOnLanding = async (liVal = '', liTrd = '', faqType = '', othersData = []) => {
    const userTypeVal =
      faqType === 'landing_track'
        ? `${trackUserType?.[optionsTrackerData?.contractType] || trackUserType?.[optionsData?.contractType]}`
        : authState?.sidResponse
          ? `${trackUserType?.[contractType]}`
          : 'non_login';
    if (
      userTypeVal !== 'undefined' &&
      ((projectId === 'csportal' && optionsTrackerData && optionsTrackerData?.options?.length > 0) || faqType)
    ) {
      try {
        let sessionId = getCookie('session_id');
        if (!sessionId) {
          sessionStorage.setItem('session_id', sessionId);
        }
        if (!sessionId) {
          sessionId = Math.random().toString(36).slice(2);
          document.cookie = `session_id=${sessionId}; path=/;`;
          sessionStorage.setItem('session_id', sessionId);
        }

        if (sessionId) {
          const jduId = userDetails?.jduid || '';
          const sectionsData = optionsTrackerData?.options?.map((each) => each.title);
          const sectionOthersData = othersData?.map((item) => item.title);

          const trdObj = {
            cname: selectedBusiness?.compname || '',
            cta_name: '',
            docid: selectedBusiness?.docid || '',
            city: selectedBusiness?.city || '',
            dcity: selectedBusiness?.data_city || '',
            area: selectedBusiness?.areaname || '',
            pin: selectedBusiness?.pincode || '',
            ds: '',
            pdg: '',
            paid: selectedBusiness?.paidstatus || '',
            usertype: userTypeVal,
            jd_verified: '',
            guarantee: '',
            trust: '',
            verified: '',
            tag: '',
            pos: '',
            li: liTrd,
            sections: [],
          };
          if (liTrd === 'landing') {
            trdObj.sections = sectionsData || [];
            trdObj.cta_name = ['Chat with Us', 'Get a Callback'];
          }
          if (liVal === 'click') {
            trdObj.sections = faqType === 'Others' ? sectionOthersData : '';
            trdObj.cta_name = '';
          }

          const paramsData = {
            session_id: sessionId,
            search_id: sessionId,
            trd: [trdObj],
            li: liVal,
            ll: 'cshmpg',
            referrer: 'auto',
            user_ip: '',
            city: selectedBusiness?.city || '',
            data_city: selectedBusiness?.data_city || '',
            area: selectedBusiness?.areaname || '',
            pincode: selectedBusiness?.pincode || '',
            jduid: jduId || '',
            mobile: userDetails?.mobile || '',
            request_time: '',
            device_src: getCookie('device_src') || '2',
            device_id: '',
            category_name: '',
            user_agent: '',
            sid: getCookie('sid') || '',
            jde: '',
            vid: '615',
            env,
            utm_source: '',
            utm_medium: '',
            utm_campaign: '',
            app_version: '',
            transaction_id: '',
          };
          await getClickTrackersInfo(paramsData);
        }
      } catch (err) {
        console.log('ERROR in handleClickTrackers', err);
      }
    }
  };

  const generateManageCampaignLeads = async () => {
    let platformVal = '';
    if (webSource.includes(source)) {
      platformVal = 'website';
    } else if (touchSource.includes(source)) {
      platformVal = 'touch';
    } else if (andriodSource.includes(source)) {
      platformVal = 'android';
    } else if (iosSource.includes(source)) {
      platformVal = 'ios';
    } else {
      platformVal = 'jdlite';
    }
    try {
      const paramsBody = {
        docid: selectedBusiness?.docid || '',
        parentid: selectedBusiness?.parentid || '',
        data_city: selectedBusiness?.data_city || '',
        pincode: selectedBusiness?.pincode || '',
        company_name: selectedBusiness?.compname || '',
        email: userDetails?.email || '',
        mobile1: userDetails?.mobile || '',
        platform: platformVal,
      };
      await generateLeads(paramsBody);
    } catch (err) {
      console.log('Error in generateManageCampaignLeads', err);
    }
  };

  const handleFaqRedirection = (optionObj, questionId = '') => {
    localStorage.setItem('searchQid', questionId);
    const { key } = optionObj;
    const liVal = 'click';
    const liTrd = `issue_${trackerObj?.[key]}`;
    const faqType = key;
    if (!questionId) {
      handleOnLanding(liVal, liTrd, faqType);
    }
    let url = '';
    if (key === 'Leads' && authState?.sidResponse) {
      url = '/csportal/leads';
    } else if (key === 'Payments' && authState?.sidResponse) {
      url = '/csportal/payments';
    } else if (key === 'Edit-my-Business' && authState?.sidResponse) {
      url = '/csportal/edit_business';
    } else if (key === 'Contract-Information') {
      url = '/csportal/contract';
    } else if (key === 'ECS') {
      url = '/csportal/ecs';
    } else if (key === 'Banner-JDRR') {
      url = '/csportal/banner';
    } else if (key === 'jdrrCertificate') {
      sessionStorage.setItem('bannerType', 'JDRR Certificate');
      sessionStorage.setItem('activeBannerFlag', 'JDRR Certificate');
      url = `/csportal/banner?jdrrCertificate=1&source=${source}`;
      navigate(url);
      return;
    } else {
      let faqParams = key;
      if (key?.includes('_')) faqParams = key?.split('_')[0];
      navigate(
        `/csportal/faq/${faqParams}?source=${source}&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}`,
      );
      return;
    }
    url += `?source=${source}`;
    navigate(url);
  };

  const handleOptionClick = async (option, questionId = '') => {
    try {
      let finalUrl = '';
      let web = false;
      onClickEvent(`CSMain-${type}`, option.title, option.title);
      if (type === 'business' && queryParams?.get('vertical') === 'leadDashBoard') {
        await clickTracker(`CS-FAQ-leadDashBoard-${option?.title || ''}`, 'leadDashBoard');
      }
      setPopupTitle(option.title);
      if (contractType === 'user') {
        await clickTracker(userTypeTrackerObj?.[option?.key], 'User_issue');
      } else if (trackUserType?.[contractType]) {
        await clickTracker(`issue_${trackerObj?.[option?.key]}`, `${trackUserType?.[contractType]}_issue`);
      }

      if (getUserType?.[contractType]) {
        onClickEvent(
          `CSMain-${getUserType?.[contractType]}-${getTextWithNoSpace(option?.title)}`,
          `${getUserType?.[contractType]}-${getTextWithNoSpace(option?.title)}`,
          `${getUserType?.[contractType]}-${getTextWithNoSpace(option?.title)}`,
        );
      }

      if (option.key === 'wantLeads') {
        if (appState?.loginPopup?.nonlogin && !sidResponse) {
          handleLoginPopup(appDispatch, {
            ...appState.loginPopup,
            open: true,
            click: true,
            nonLoginGrievancePopup: true,
          });
          return;
        }
        await clickTracker(
          ['expiredLong', 'free'].includes(contractType)
            ? 'promotenow_cs'
            : contractType === 'paid'
              ? 'managecampaign_cs'
              : `issue_${trackerObj?.[option?.key]}`,
          'customer_support',
        );
        const liVal = 'click';
        const liTrd = `issue_${trackerObj?.[option?.key]}`;
        const faqType = option?.key;
        handleOnLanding(liVal, liTrd, faqType);
        generateManageCampaignLeads();
        if (andriodSource.includes(source)) {
          const data = {};
          data['ürl'] = option.url;
          data.header = '';
          data.confirmationheader = '';
          data.hide_header = 1;
          data.webviewhistory = 0;
          data.transaction = 0;
          window.JdLiteInterface?.openUrlInWindow(JSON.stringify(data));
        } else if (iosSource.includes(source)) {
          const url = `${option.url}&wkwebview=1`;
          const paramsIos = { type: 'deeplinkJD', shareUrl: url };
          window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(paramsIos));
        } else if (touchSource.includes(source)) {
          const url = `${option.url}&touch=1`;
          window.location.href = url;
        } else {
          window.location.href = option.url;
        }

        return;
      }

      switch (option.type) {
        case 'others': {
          const liVal = 'click';
          const liTrd = 'Others';
          const faqType = 'Others';
          if (selectedBusiness?.active && selectedBusiness?.paidstatus === 1) {
            handleOnLanding(liVal, liTrd, faqType, option?.data);
            setOthersPopupData(option?.data);
          } else {
            const updatedOthersData = option?.data?.filter((each) => each?.key !== 'grievanceRedressal');
            handleOnLanding(liVal, liTrd, faqType, updatedOthersData);
            setOthersPopupData(updatedOthersData);
          }
          setPopup({
            open: true,
            popupType: 'OthersPopup',
            heading: 'Others',
          });

          return;
        }
        case 'popup': {
          const updatedUserDetails = {
            ...userDetails,
            issueType: option.issue,
            issueSubType: option.subIssue,
          };
          setUserDetails('userDetails', JSON.stringify(updatedUserDetails));
          document.body.style.overflow = 'hidden';
          setPopup({
            open: true,
            popupType: 'UserGrievancePopup',
            heading: 'Grievance Redressal',
            subHeading:
              'In the event that you are not satisfied with the resolution provided by our team you can contact our grievance redressal officer.',
            placeholder: 'Please write your query here, and our Grievance Redressal team will act on it in 24-48 hours',
          });
          const liVal = 'click';
          const liTrd = `issue_grievance`;
          const faqType = option?.key;
          handleOnLanding(liVal, liTrd, faqType);

          return;
        }
        case 'redirect': {
          const liVal = 'click';
          const liTrd = `issue_${trackerObj?.[option?.key]}`;
          const faqType = option?.key;
          handleOnLanding(liVal, liTrd, faqType);
          if (appState?.loginPopup?.nonlogin && !sidResponse && option.key !== 'omni') {
            handleLoginPopup(appDispatch, {
              ...appState.loginPopup,
              open: true,
              click: true,
              nonLoginGrievancePopup: true,
            });
            return;
          }
          if (option?.key === 'wantLeads') {
            await clickTracker(
              ['expiredLong', 'free'].includes(contractType)
                ? 'promotenow_cs'
                : contractType === 'paid'
                  ? 'managecampaign_cs'
                  : `issue_${trackerObj?.[option?.key]}`,
              'customer_support',
            );
            generateManageCampaignLeads();
          }
          finalUrl = source === '2' && option.source2Url ? option.source2Url : option.url;
          break;
        }
        case 'create': {
          finalUrl = `https://wap.justdial.com/free_listing.php?m=1&old=1&mobile=${
            userDetails?.mobile || ''
          }&name=${userDetails?.fullName || ''}&hide_header=1&wkwebview=1`;
          break;
        }
        case 'faq': {
          handleSetFaqData(appDispatch, {
            faqData: [],
          });
          if (authState?.sidResponse && option?.key === 'JD-Pay') {
            handleJdPayRedirection();
            return;
          }
          handleFaqRedirection(option, questionId);
          return;
        }
        case 'chat': {
          finalUrl = option.url;
          web = true;
          break;
        }
        case 'pageUser': {
          sessionStorage.setItem('faq', 'userReport');
          const liVal = 'click';
          const liTrd = `issue_${trackerObj?.[option?.key]}`;
          const faqType = option?.key;
          handleOnLanding(liVal, liTrd, faqType);
          if ((appState?.loginPopup?.nonlogin && !type) || !sidResponse) {
            handleLoginPopup(appDispatch, {
              ...appState.loginPopup,
              open: true,
              click: true,
              nonLoginGrievancePopup: 1,
            });
            return;
          }
          navigate('/csportal/userReport');
          return;
        }
        default: {
          finalUrl = option.url;
        }
      }
      if (finalUrl && finalUrl !== '') {
        handleRedirection(source, finalUrl, web);
      }
    } catch (err) {
      console.log('Err in option click', err);
      setAlert({
        message: 'Something went wrong!',
        status: false,
      });
    }
  };

  const handleClosePopup = async () => {
    sessionStorage.removeItem('faq');
    onClickEvent(`CSMain-${type}`, 'Cancel', 'Cancel');
    document.body.style.overflow = 'unset';
    setComment('');
    setPopup({});
    if (['user', 'free'].includes(contractType) && popupObj?.popupType === 'UserGrievancePopup') {
      await clickTracker('User_grievancepopup_Cancel', 'User_issue');
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = 'grievance_cancel';
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = ``;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
  };

  useEffect(() => {
    if (
      ((createTicketFlag !== '1' && Object.keys(selectedBusiness).length === 0) ||
        (createTicketFlag === '1' &&
          Object.keys(selectedBusiness).length === 0 &&
          JSON.parse(sessionStorage.getItem('contractType') !== 'user'))) &&
      allBusinesses?.length > 0
    ) {
      setSelectedBusinessState(allBusinesses[0]);
      if (allBusinesses.length > 1 && !urlDocId) {
        document.body.style.overflow = 'hidden';
        setPopup({ open: true, popupType: 'selectBusiness' });
      } else if (createTicketFlag === '1' && allBusinesses?.length === 1) {
        const businessSelected = allBusinesses?.[0] || {};
        if (businessSelected?.parentid && businessSelected?.data_city) {
          navigate(
            `/csportal/create_ticket?parentId=${businessSelected?.parentid}&city=${
              businessSelected?.data_city
            }&key=''&vertical=${queryParams?.get('vertical') === 'leadDashBoard' ? 'leadDashBoard' : ''}
&raiseTicketTrackerID=`,
          );
        }
      }
      setIsBusinessChange(true);
    } else if (
      authState?.sidResponse &&
      createTicketFlag === '1' &&
      allBusinesses?.length === 0 &&
      sessionStorage.getItem('faq') !== 'userReport' &&
      JSON.parse(sessionStorage.getItem('contractType')) === 'user'
    ) {
      sessionStorage.setItem('faq', 'userReport');
      navigate('/csportal/userReport');
    }
  }, [allBusinesses, sessionStorage.getItem('contractType')]);

  const handleCommentSubmit = async () => {
    document.body.style.overflow = 'none';
    if (appState?.loginPopup?.nonlogin && !sidResponse) {
      setComment('');
      setPopup({});
      handleLoginPopup(appDispatch, {
        ...appState.loginPopup,
        open: true,
        click: true,
        nonLoginGrievancePopup: !sidResponse && popupObj?.popupType === 'UserGrievancePopup' ? true : '',
      });
      return;
    }
    onClickEvent(`CSMain-${type}`, 'Submit', 'Submit');
    try {
      const hasBusiness = type === 'business';
      const paramsData = {
        vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'USER EXPERIENCE',
        category: 'CS',
        ticket_creator: hasBusiness ? 'BUSINESS' : 'USER',
        nm: userDetails?.fullName || '',
        created_by: userDetails?.mobile || '',
        mob: userDetails?.mobile || '',
        issue_type: hasBusiness ? (hasJdMartVertical() ? 'OTHER ISSUES' : 'other issues') : 'misc',
        issue_sub_type: hasBusiness
          ? hasJdMartVertical()
            ? 'USER EXPERIENCE ESCALATION'
            : 'non paid business'
          : 'misc',
        issue_comment: comment?.trim() || '',
        document: [],
        city: hasBusiness ? selectedBusiness?.data_city || '' : userDetails?.cityName || 'Mumbai',
        oid: '',
        orderid: '',
        docid: hasBusiness ? selectedBusiness?.docid || '' : '',
        src: hasBusiness ? 'BUSINESS' : 'USER',
        src_typ: 'csportal',
        src_nm: userDetails?.fullName || '',
        src_mob: userDetails?.mobile || '',
        parentId: '',
        source: 'gr pop up_submitbutton_csportal',
        tag: ['expiredLong', 'free'].includes(contractType) ? 'User grievance newCS' : 'User newCS',
      };
      const res = await CreateTicket(paramsData);
      setAlert({
        message: res?.errorCode === 0 ? res?.result?.msg : res?.result?.msg || 'Something went wrong',
        status: res?.errorCode === 0,
      });
    } catch (err) {
      console.log('Error in User_grievancepopup_ticket submit', err);
    }

    if (['user', 'free'].includes(contractType)) {
      await clickTracker('User_grievancepopup_ticket', 'User_issue');
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = 'grievance_submit';
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = ``;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
    setComment('');
    setPopup({});
  };

  useEffect(() => {
    try {
      if (selectedBusiness?.docid) {
        const liVal = 'impression';
        const liTrd = 'landing';
        const faqType = 'landing_track';
        handleOnLanding(liVal, liTrd, faqType);
      }
    } catch (err) {
      console.log('ERROR in handleClickTrackers', err);
    }
  }, [optionsTrackerData]);
  return (
    <>
      {loader ? (
        <Shimmer loading id="home" />
      ) : authState?.sidResponse ? (
        <LoggedIn
          handleOptionClick={handleOptionClick}
          isBusinessChange={isBusinessChange}
          handleOnLanding={handleOnLanding}
          setOptionsTrackerData={setOptionsTrackerData}
        />
      ) : (!type || type === '') && !authState?.sidResponse ? (
        <NonLoginHome />
      ) : (
        <NonLoginBody handleOptionClick={handleOptionClick} handleOnLanding={handleOnLanding} />
      )}

      {popupObj?.popupType === 'selectBusiness' && (
        <BusinessPopup
          handleCloseBusinessPopup={handleClosePopup}
          setIsBusinessChange={setIsBusinessChange}
          createTicketFlag="0"
        />
      )}

      {popupObj?.popupType === 'UserGrievancePopup' && (
        <CommonPopup
          comment={comment}
          setComment={setComment}
          handleCommentSubmit={handleCommentSubmit}
          handleClosePopup={handleClosePopup}
        />
      )}

      {popupObj?.popupType === 'OthersPopup' && (
        <OthersPopup
          handleClosePopup={handleClosePopup}
          othersData={othersPopupData}
          setAlert={setAlert}
          handleFaqRedirection={handleFaqRedirection}
        />
      )}
    </>
  );
}

export default Home;
